// eslint-disable-next-line surveyjs/no-imports-from-entries
import "../../../packages/survey-core/entries/chunks/localization";